module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av714-defe9d6e7b38e2355e3d544ededce030.jpg";